export default class CustomError extends Error {
    name = ''
    code!: number | undefined
    constructor(msg: string, name = 'Error', code?: number) {
        super(msg)
        this.name = name
        this.code = code
    }
}